/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Contact_Privacy_TitleInputs */

const en_platform_contact_privacy_title = /** @type {(inputs: Platform_Contact_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy and data`)
};

const pl_platform_contact_privacy_title = /** @type {(inputs: Platform_Contact_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność i dane`)
};

/**
* | output |
* | --- |
* | "Privacy and data" |
*
* @param {Platform_Contact_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_contact_privacy_title = /** @type {((inputs?: Platform_Contact_Privacy_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Contact_Privacy_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_contact_privacy_title(inputs)
	return en_platform_contact_privacy_title(inputs)
});